export const INDUSTRY_LIST = "INDUSTRY_LIST";
export const GEOLOCATION = "GEOLOCATION";
export const COMPANY_TYPE = "COMPANY_TYPE";
export const EMPLOYEE_COUNT = "EMPLOYEE_COUNT";
export const REVENUE_RANGE = "REVENUE_RANGE";
export const COMPANYLIST = "COMPANYLIST";
export const COMPANY_SEARCH_PAYLOAD = "COMPANY_SEARCH_PAYLOAD";
export const ADVANCED_SELECTED_FILTERS = "ADVANCED_SELECTED_FILTERS";
export const PAGINATION_VALUE = "PAGINATION_VALUE";
export const SELECTED_RECORDS = "SELECTED_RECORDS";
export const SAVE_SEARCH = "SAVE_SEARCH";
export const SAVE_SEARCH_LIST = "SAVE_SEARCH_LIST";
export const COMPANY_TAG_LIST = "COMPANY_TAG_LIST";

export const EMPTY_ERROR_OBJ_LISTING = "EMPTY_ERROR_OBJ_LISTING";
export const INDUSTRY_LIST_ERROR = "INDUSTRY_LIST_ERROR";
export const GEOLOCATION_ERROR = "GEOLOCATION_ERROR";
export const COMPANY_TYPE_ERROR = "COMPANY_TYPE_ERROR";
export const EMPLOYEE_COUNT_ERROR = "EMPLOYEE_COUNT_ERROR";
export const REVENUE_RANGE_ERROR = "REVENUE_RANGE_ERROR";
export const COMPANYLIST_ERROR = "COMPANYLIST_ERROR";
export const COMPANY_SEARCH_PAYLOAD_ERROR = "COMPANY_SEARCH_PAYLOAD_ERROR";
export const ADVANCED_SELECTED_FILTERS_ERROR =
  "ADVANCED_SELECTED_FILTERS_ERROR";
export const PAGINATION_VALUE_ERROR = "PAGINATION_VALUE_ERROR";
export const DOWNLOAD_COMPANYLIST_ERROR = "DOWNLOAD_COMPANYLIST_ERROR";
export const SELECTED_RECORDS_ERROR = "SELECTED_RECORDS_ERROR";
export const SAVE_SEARCH_ERROR = "SAVE_SEARCH_ERROR";
export const SAVE_SEARCH_LIST_ERROR = "SAVE_SEARCH_LIST_ERROR";
export const COMPANY_TAG_LIST_ERROR = "COMPANY_TAG_LIST_ERROR";
export const COMPANYQUICKSELECTIONLIST_ERROR =
  "COMPANYQUICKSELECTIONLIST_ERROR";
export const COMPANYQUICKSELECTIONLIST = "COMPANYQUICKSELECTIONLIST";
